(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-image-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-image-badge')) {
    customElements.define('product-image-badge', class extends HTMLElement {
      connectedCallback() {
        this.image = this.parentElement.querySelector(':scope > img');
        this.badge = this.querySelector('.product-image-badge');
        if (!this.image || !this.badge) return;

        this.onLoad = () => this.measureProduct();
        this.image.addEventListener('load', this.onLoad);
        this.observer = new ResizeObserver(() => this.updateSize());
        this.observer.observe(this.parentElement);
        if (this.image.complete && this.image.naturalWidth) this.measureProduct();
      }

      disconnectedCallback() {
        this.image?.removeEventListener('load', this.onLoad);
        this.observer?.disconnect();
      }

      measureProduct() {
        this.points = null;
        this.badge.style.removeProperty('--badge-size');
        try {
          const canvas = document.createElement('canvas');
          const scale = 144 / Math.max(this.image.naturalWidth, this.image.naturalHeight);
          canvas.width = Math.max(1, Math.round(this.image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(this.image.naturalHeight * scale));
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(this.image, 0, 0, canvas.width, canvas.height);
          const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          this.points = [];
          for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
              const i = (y * canvas.width + x) * 4;
              if (pixels[i + 3] > 32 && Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) < 225) {
                this.points.push([(x + 0.5) / canvas.width, (y + 0.5) / canvas.height]);
              }
            }
          }
        } catch {
          this.points = null;
        }
        this.updateSize();
      }

      updateSize() {
        if (!this.badge || !this.points || !this.image.complete || !this.image.naturalWidth ||
            !this.image.naturalHeight) {
          this.badge?.style.removeProperty('--badge-size');
          return;
        }
        const frame = this.getBoundingClientRect();
        const image = this.image.getBoundingClientRect();
        if (!frame.width || !image.width || !image.height) return;

        const scale = Math.min(image.width / this.image.naturalWidth, image.height / this.image.naturalHeight);
        const width = this.image.naturalWidth * scale;
        const height = this.image.naturalHeight * scale;
        const position = getComputedStyle(this.image).objectPosition.split(' ');
        const offset = (value) => value?.endsWith('%') ? parseFloat(value) / 100 : 0.5;
        const left = image.left + (image.width - width) * offset(position[0]);
        const top = image.top + (image.height - height) * offset(position[1]);
        const style = getComputedStyle(this.badge);
        const edgeGap = parseFloat(style.right);
        const bottomGap = parseFloat(style.bottom);
        const cornerX = frame.right - edgeGap;
        const cornerY = frame.bottom - bottomGap;
        const badgeImage = this.badge.querySelector('img');
        const ratio = Number(badgeImage.getAttribute('height')) / Number(badgeImage.getAttribute('width')) || 1;
        const mobile = matchMedia('(max-width: 749px)').matches;
        const gap = mobile ? 6 : 10;
        let available = Math.min(
          width * (mobile ? 0.24 : 0.32),
          frame.width - edgeGap * 2,
          (frame.height - bottomGap - edgeGap) / ratio
        );
        for (const [x, y] of this.points) {
          const px = left + x * width;
          const py = top + y * height;
          if (px > cornerX + gap || py > cornerY + gap) continue;
          available = Math.min(available, Math.max(cornerX - px - gap, (cornerY - py - gap) / ratio));
        }
        this.badge.style.setProperty('--badge-size', `${Math.max(0, available)}px`);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
